import SystemEyeLine from './system-eye-line.component.js'

export * from './system-eye-line.component.js'
export default SystemEyeLine

SystemEyeLine.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-icon-eye-line': SystemEyeLine
  }
}
